import React from 'react';
import { Fit } from '../enums/Fit.enum';
import { Dropdown, DropdownProps } from './Dropdown';

export const FitDropdown: React.FC<DropdownProps<Fit>> = (props) => <Dropdown {...props} allValues={Object.values(Fit)} />;

export default FitDropdown;
